module.exports = __webpack_public_path__ + "static/media/notfound.a85549a1.svg";